import { ComponentPropsWithoutRef } from 'react';

type IconSparkleProps = {
  width?: string;
  height?: string;
} & ComponentPropsWithoutRef<'svg'>;
export const IconSparkle = ({ width = '1.2em', height = '1.2em', ...rest }: IconSparkleProps) => (
  <svg
    width={width}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    {...rest}
  >
    <path
      d="M3.167 1.5v3.333V1.5ZM1.5 3.167h3.333H1.5Zm2.5 10V16.5v-3.333Zm-1.667 1.666h3.334-3.334ZM9.833 1.5l1.905 5.714L16.5 9l-4.762 1.786L9.833 16.5l-1.905-5.714L3.167 9l4.761-1.786L9.833 1.5Z"
      stroke="#163608"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
